/* eslint-disable react/destructuring-assignment */
import styles from './button.module.scss'

interface IHeader {
  isPrimary?: boolean
  outline?: 'white' | 'black'
  name: string
  onClick: Function
}

const Button = (props: IHeader) => {
  const { onClick, name, isPrimary, outline } = props

  const outlineClassMapper = {
    white: styles.whiteOutlineButton,
    black: styles.blackOutlineButton,
  }

  const buttonClass = outline ? outlineClassMapper[outline] : isPrimary ? styles.primaryButton : styles.secondaryButton

  return (
    // eslint-disable-next-line react/button-has-type
    <button onClick={() => onClick()} className={`${styles.button} ${buttonClass}`}>
      {name}
    </button>
  )
}
export default Button
